import { useState, useEffect } from 'react';

import { useDomainContext } from 'src/contexts/domain-context';

export const useLocalDomainInfo = () => {
  const [domainInfo, setDomainInfo] = useState(null);

  const { domainData } = useDomainContext();

  useEffect(() => {
    const domainInfoLocal = localStorage.getItem('domain_data')
      ? JSON.parse(localStorage.getItem('domain_data'))
      : null;

    if (domainInfoLocal) {
      setDomainInfo(domainInfoLocal);
    } else {
      setDomainInfo(domainData);
    }
  }, [domainData]);

  return { domainData: domainInfo };
};
